// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qf_a bhe_su bhe_kv bhe_kw","PostDetailRight__brandDaysPosts":"qf_b bhe_su bhe_kv bhe_kw"};